
import { useEffect, useRef } from 'react';
import { useAuth } from '@/context/AuthContext';

/**
 * Custom hook that provides stable authentication state
 * Prevents unnecessary re-renders when browser tab/window focus changes
 */
export const useStableAuth = () => {
  const auth = useAuth();
  const stableAuthRef = useRef(auth);
  const isInitialLoad = useRef(true);

  useEffect(() => {
    // Only update the stable ref when authentication state actually changes
    // Not when browser focus changes or other non-auth events occur
    if (
      isInitialLoad.current ||
      auth.user?.id !== stableAuthRef.current.user?.id ||
      auth.loading !== stableAuthRef.current.loading ||
      auth.isAuthenticated !== stableAuthRef.current.isAuthenticated
    ) {
      stableAuthRef.current = auth;
      isInitialLoad.current = false;
    }
  }, [auth.user?.id, auth.loading, auth.isAuthenticated]);

  return stableAuthRef.current;
};
